// ProductionReducer.js — Manufacturer Module, Phase 3, Steps 7-12.
// Backs Production Order screens only. Wired into rootReducer.js as `production`.

const initialState = {
  orders: [],
  selectedOrder: null,
  costHistory: [],
  costHistoryLoading: false,
  loading: false,
  actionLoading: false,
  bulkLoading: false,
  bulkResults: [],
  recheckingId: null,
  // Batch timeline (list page) — GET /production/batches
  batchedItems: [],
  batchedLoading: false,
  confirmingBatchId: null,
  recheckingBatchId: null,
  error: null
};

const ProductionReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_PRODUCTION_ORDERS_REQUEST':
      return { ...state, loading: true, error: null };
    case 'FETCH_PRODUCTION_ORDERS_SUCCESS':
      return { ...state, loading: false, orders: action.payload, error: null };
    case 'FETCH_PRODUCTION_ORDERS_FAILURE':
      return { ...state, loading: false, error: action.payload };

    case 'GET_PRODUCTION_ORDER_REQUEST':
      return { ...state, actionLoading: true, error: null };
    case 'GET_PRODUCTION_ORDER_SUCCESS':
      return { ...state, actionLoading: false, selectedOrder: action.payload, error: null };
    case 'GET_PRODUCTION_ORDER_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    case 'CREATE_PRODUCTION_ORDER_REQUEST':
    case 'CONFIRM_PRODUCTION_ORDER_REQUEST':
    case 'CANCEL_PRODUCTION_ORDER_REQUEST':
      return { ...state, actionLoading: true, error: null };

    case 'CREATE_PRODUCTION_ORDER_SUCCESS':
      return { ...state, actionLoading: false };

    case 'CONFIRM_PRODUCTION_ORDER_SUCCESS':
      return {
        ...state,
        actionLoading: false,
        orders: state.orders.map((o) => (o.id === action.payload ? { ...o, status: 'confirmed' } : o)),
        selectedOrder:
          state.selectedOrder && state.selectedOrder.id === action.payload
            ? { ...state.selectedOrder, status: 'confirmed' }
            : state.selectedOrder
      };

    case 'CANCEL_PRODUCTION_ORDER_SUCCESS':
      return {
        ...state,
        actionLoading: false,
        orders: state.orders.map((o) => (o.id === action.payload ? { ...o, status: 'cancelled' } : o)),
        selectedOrder:
          state.selectedOrder && state.selectedOrder.id === action.payload
            ? { ...state.selectedOrder, status: 'cancelled' }
            : state.selectedOrder
      };

    case 'CREATE_PRODUCTION_ORDER_FAILURE':
    case 'CONFIRM_PRODUCTION_ORDER_FAILURE':
    case 'CANCEL_PRODUCTION_ORDER_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    // Bulk create — batch screen (multiple recipe rows at once)
    case 'BULK_CREATE_PRODUCTION_ORDERS_REQUEST':
      return { ...state, bulkLoading: true, bulkResults: [], error: null };
    case 'BULK_CREATE_PRODUCTION_ORDERS_SUCCESS':
      return { ...state, bulkLoading: false, bulkResults: action.payload };
    case 'BULK_CREATE_PRODUCTION_ORDERS_FAILURE':
      return { ...state, bulkLoading: false, error: action.payload };
    case 'CLEAR_BULK_PRODUCTION_RESULTS':
      return { ...state, bulkResults: [] };

    // SO shortage -> Production Order modal (Stock Shortage flow, Step 5)
    case 'CREATE_PRODUCTION_FROM_SHORTAGE_REQUEST':
      return { ...state, actionLoading: true, error: null };
    case 'CREATE_PRODUCTION_FROM_SHORTAGE_SUCCESS':
      return { ...state, actionLoading: false };
    case 'CREATE_PRODUCTION_FROM_SHORTAGE_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    // Re-check Stock — draft -> pending promotion attempt
    case 'RECHECK_PRODUCTION_ORDER_REQUEST':
      return { ...state, recheckingId: action.payload || true };
    case 'RECHECK_PRODUCTION_ORDER_SUCCESS': {
      const { id, promoted, shortage_notes } = action.payload;
      const patch = promoted ? { status: 'pending', shortage_notes: null } : { shortage_notes };
      return {
        ...state,
        recheckingId: null,
        orders: state.orders.map((o) => (o.id === id ? { ...o, ...patch } : o)),
        selectedOrder: state.selectedOrder && state.selectedOrder.id === id ? { ...state.selectedOrder, ...patch } : state.selectedOrder
      };
    }
    case 'RECHECK_PRODUCTION_ORDER_FAILURE':
      return { ...state, recheckingId: null, error: action.payload };

    case 'CLEAR_SELECTED_PRODUCTION_ORDER':
      return { ...state, selectedOrder: null };

    // Batch timeline (list page)
    case 'FETCH_PRODUCTION_BATCHES_REQUEST':
      return { ...state, batchedLoading: true, error: null };
    case 'FETCH_PRODUCTION_BATCHES_SUCCESS':
      return { ...state, batchedLoading: false, batchedItems: action.payload, error: null };
    case 'FETCH_PRODUCTION_BATCHES_FAILURE':
      return { ...state, batchedLoading: false, error: action.payload };

    case 'CONFIRM_ALL_IN_BATCH_REQUEST':
      return { ...state, confirmingBatchId: action.payload, error: null };
    case 'CONFIRM_ALL_IN_BATCH_SUCCESS':
      return { ...state, confirmingBatchId: null };
    case 'CONFIRM_ALL_IN_BATCH_FAILURE':
      return { ...state, confirmingBatchId: null, error: action.payload };

    case 'RECHECK_ALL_IN_BATCH_REQUEST':
      return { ...state, recheckingBatchId: action.payload, error: null };
    case 'RECHECK_ALL_IN_BATCH_SUCCESS':
      return { ...state, recheckingBatchId: null };
    case 'RECHECK_ALL_IN_BATCH_FAILURE':
      return { ...state, recheckingBatchId: null, error: action.payload };

    // Phase 4 — cost history for one Finish Good product
    case 'FETCH_PRODUCTION_COST_HISTORY_REQUEST':
      return { ...state, costHistoryLoading: true };
    case 'FETCH_PRODUCTION_COST_HISTORY_SUCCESS':
      return { ...state, costHistoryLoading: false, costHistory: action.payload };
    case 'FETCH_PRODUCTION_COST_HISTORY_FAILURE':
      return { ...state, costHistoryLoading: false };
    case 'CLEAR_PRODUCTION_COST_HISTORY':
      return { ...state, costHistory: [] };

    default:
      return state;
  }
};

export default ProductionReducer;